import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";
import { getUserDetails } from "../utils/userDetailsUtils";

const saveUserExecutionSetup = async (payload) => {
  const user = getUserDetails();

  const { useUserExecution, executionUrl } = payload.payload;

  const response = await axios.get(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}`, {
    params: {
      action: "saveUserExecutionSetuphub",
      username: user.products[0].iduserprofile,
      useUserExecution,
      executionUrl,
    },
  });

  return response.data;
};

const useSaveUserExecutionSetupQuery = () => {
  return useMutation({
    mutationFn: saveUserExecutionSetup,
  });
};

export default useSaveUserExecutionSetupQuery;
